﻿import {Controller} from "./helpers/controller";
import {centerListing, findCenterControl} from "./findCenterControl";

export class MembershipCenterPopupControl extends Controller {
    
    private centerListing?: centerListing;
    private findCenter: findCenterControl;

    private centreSelectForm: JQuery = $('[data-switch-choose-centre-form]');


    constructor(element: HTMLElement) {
        super(element);

        this.findCenter = new findCenterControl(element, false, this.centerSelect, this.onlineSelect, true);
    }
    
    
    centerSelect = (center: centerListing) =>{
        this.centerListing = center;
        this.findCenter.close();

        // Store the centre details we need
        this.centreSelectForm.find('#inCentre').val(this.centerListing.centerId);
        this.centreSelectForm.find('#centreName').val(this.centerListing.name);

        // Submit the form
        this.centreSelectForm.submit();
    }


    onlineSelect = () => {
        this.findCenter.close();

        // Select online and store the centre details we need
        this.centreSelectForm.find('#online').prop("checked", true);
        this.centreSelectForm.find('#centreName').val('Online');

        // Submit the form
        this.centreSelectForm.submit();
    }
}